var exports = {
  "uW": "GameActivityProfileSection.module__section___N3hRUz",
  "Gf": "GameActivityProfileSection.module__sectionTitle___N3hRUz",
  "Nr": "GameActivityProfileSection.module__card___N3hRUz",
  "jy": "GameActivityProfileSection.module__gameIconPlaceholder___N3hRUz",
  "T_": "GameActivityProfileSection.module__gameIconImage___N3hRUz",
  "Gt": "GameActivityProfileSection.module__gameIcon___N3hRUz",
  "zI": "GameActivityProfileSection.module__cardBody___N3hRUz",
  "mO": "GameActivityProfileSection.module__gameName___N3hRUz",
  "re": "GameActivityProfileSection.module__durationRow___N3hRUz",
  "c5": "GameActivityProfileSection.module__durationIcon___N3hRUz",
  "S5": "GameActivityProfileSection.module__durationText___N3hRUz",
};

module.exports = exports;
